/**
 * Rounds the decimal part of a number
 * @param num - The number to round
 * @param digits - Number of digits in the decimal, defaults to 0
 */
export function toFixedNumber(number: number, digits = 0): number {
  const pow = Math.pow(10, digits);
  return Math.round(number * pow) / pow;
}
/**
 * Restrict a number between a minimum and a maximum bound.
 * @param number - Number to clamp
 * @param min - Lower limit
 * @param max - Upper limit
 */
export function clamp(number: number, min: number, max: number): number {
  return Math.min(Math.max(number, min), max);
}

/**
 * Linearly interpolates between two values.
 * @param start - The starting value.
 * @param end - The ending value.
 * @param amount - The interpolation amount between 0 and 1.
 */
export function lerp(start: number, end: number, amount: number): number {
  return (1 - amount) * start + amount * end;
}
